/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Approval_Required_HintInputs */

const en_admin_resource_form_approval_required_hint = /** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource bookings must be approved by an admin when booked via the external portal`)
};

const de_admin_resource_form_approval_required_hint = /** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcenbuchungen müssen von einem Admin bestätigt werden, wenn sie über die Homepage gebucht werden.`)
};

const es_admin_resource_form_approval_required_hint = /** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las reservas de recursos deben ser aprobadas por un administrador cuando se reservan a través del Portal Público de Visitantes`)
};

const fr_admin_resource_form_approval_required_hint = /** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les réservations de ressources doivent être approuvées par un administrateur lorsqu'elles sont réservées via le Portail Public de Visiteurs.`)
};

const nl_admin_resource_form_approval_required_hint = /** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringen van voorzieningen moeten door een admin worden goedgekeurd wanneer ze via het externe portaal worden gemaakt`)
};

/** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */
const it_admin_resource_form_approval_required_hint = en_admin_resource_form_approval_required_hint;

/** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_approval_required_hint = en_admin_resource_form_approval_required_hint;

/** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */
const pl_admin_resource_form_approval_required_hint = en_admin_resource_form_approval_required_hint;

/** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */
const hu_admin_resource_form_approval_required_hint = en_admin_resource_form_approval_required_hint;

/** @type {(inputs: Admin_Resource_Form_Approval_Required_HintInputs) => LocalizedString} */
const ro_admin_resource_form_approval_required_hint = en_admin_resource_form_approval_required_hint;

/**
* | output |
* | --- |
* | "Resource bookings must be approved by an admin when booked via the external portal" |
*
* @param {Admin_Resource_Form_Approval_Required_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_approval_required_hint = /** @type {((inputs?: Admin_Resource_Form_Approval_Required_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Approval_Required_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_approval_required_hint(inputs)
	if (locale === "de") return de_admin_resource_form_approval_required_hint(inputs)
	if (locale === "es") return es_admin_resource_form_approval_required_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_approval_required_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_approval_required_hint(inputs)
	if (locale === "it") return it_admin_resource_form_approval_required_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_approval_required_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_approval_required_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_approval_required_hint(inputs)
	return ro_admin_resource_form_approval_required_hint(inputs)
});
export { admin_resource_form_approval_required_hint as "admin.resource_form.approval_required_hint" }